const toggleDropdown = (el) => {
    $(el).toggleClass('active').next().slideToggle();
    $(el).parent().toggleClass('active');
}

$(document).on('click', '.dropdown-menu-toggler', function() {
    $('.dropdown-menu-toggler.active').not($(this)).each(function() {
        toggleDropdown($(this));
    });
    toggleDropdown($(this));
});
